export default __webpack_public_path__ + "static/media/ic_cook_islands.fa612fd5.svg";